import React from 'react'
import type { StepData } from '../../../services/onboardingService'

interface QuoteReviewStepProps {
  onComplete?: (stepData: StepData) => Promise<void>
  stepData?: any
  stepKey?: string
}

const QuoteReviewStep: React.FC<QuoteReviewStepProps> = ({
  onComplete,
  stepData,
}) => {
  const handleComplete = async () => {
    if (onComplete) {
      await onComplete({
        completedAt: new Date().toISOString(),
        placeholder: true,
      })
    }
  }

  return (
    <div className="max-w-2xl mx-auto">
      <div className="mb-6">
        <h2 className="text-xl font-semibold text-gray-900 mb-2">
          Revisión de Cotización y Aceptación
        </h2>
        <p className="text-gray-600">
          Revisión y aceptación de la propuesta comercial
        </p>
      </div>

      {stepData?.status === 'completed' && (
        <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-lg">
          <div className="flex items-center">
            <svg
              className="w-5 h-5 text-green-600 mr-2"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M5 13l4 4L19 7"
              />
            </svg>
            <span className="text-green-800 font-medium">
              Cotización aceptada exitosamente
            </span>
          </div>
        </div>
      )}

      <div className="bg-white p-8 rounded-lg border border-gray-200">
        <div className="text-center">
          <div className="mb-4">
            <div className="mx-auto w-16 h-16 bg-emerald-100 rounded-full flex items-center justify-center">
              <svg
                className="w-8 h-8 text-emerald-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"
                />
              </svg>
            </div>
          </div>
          <h3 className="text-lg font-semibold text-gray-900 mb-2">
            Revisión y Aceptación de Cotización
          </h3>
          <p className="text-gray-600 mb-6">
            Aquí podrás revisar los términos y condiciones finales de tu
            cotización de leasing y proceder con la aceptación formal.
          </p>

          <div className="bg-gray-50 p-4 rounded-lg mb-6">
            <p className="text-sm text-gray-700">
              <strong>Tiempo estimado:</strong> 15 minutos
            </p>
          </div>

          <div className="bg-blue-50 p-4 rounded-lg mb-6 text-left">
            <h4 className="text-sm font-semibold text-blue-800 mb-2">
              La cotización incluirá:
            </h4>
            <ul className="text-sm text-blue-700 space-y-1">
              <li>• Monto del financiamiento</li>
              <li>• Plazo del contrato</li>
              <li>• Tasa de interés aplicable</li>
              <li>• Rentas mensuales</li>
              <li>• Seguros y comisiones</li>
              <li>• Valor residual</li>
            </ul>
          </div>

          <button
            onClick={handleComplete}
            disabled={stepData?.status === 'completed'}
            className="px-6 py-3 bg-blue-600 text-white rounded-lg hover:bg-blue-700 disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {stepData?.status === 'completed'
              ? 'Completado'
              : 'Simular Completar'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default QuoteReviewStep
